/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import AppButton from '../../shared/components/app-button/AppButton';
import {
  formatCurrency,
  formatDate,
  formatTimeString,
  getNewDate,
} from '../../shared/helper-utils/appUtils';
import { ONLY_DATE_MONTH_FORMAT } from '../../shared/constants/Constants';
import AppFlightLogo from '../../shared/components/app-flight-logo/AppFlightLogo';

function DomMultiCityResultsFooter({
  journeyType,
  selectedFare,
  selectedFlight,
  domint,
  searchRequest,
  onBook,
  selectedClassInfo,
}) {
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const [showBookBtn, setShowBookBtn] = useState(false);

  const getShowStatus = () => {
    let isShow = true;
    Object.keys(selectedFare).forEach((x) => {
      if (selectedFare[x] === undefined) {
        isShow = false;
      }
    });
    setShowBookBtn(isShow);
  };

  useEffect(() => {
    getShowStatus();
  }, [selectedFare]);

  const getTotalAmount = () => {
    let total = 0;
    Object.keys(selectedFare).forEach((x) => {
      if (selectedFare[x] !== undefined) {
        total += selectedFare[x].totalfq;
      }
    });
    return total;
  };

  const getSelectedFlightDetail = (flight, fare, isOnward, index) => {
    let fareToShow = fare;
    const selectedClasses = [];
    if (
      isOnward &&
      selectedClassInfo &&
      selectedClassInfo.selectedOnwardClassFare
    ) {
      fareToShow = selectedClassInfo.selectedOnwardClassFare;
      selectedClassInfo.selectedOnwardList.forEach((x) => {
        selectedClasses.push(x.selectedclass);
      });
    } else if (
      selectedClassInfo &&
      selectedClassInfo.selectedReturnClassFare &&
      !isOnward
    ) {
      fareToShow = selectedClassInfo.selectedReturnClassFare;
      selectedClassInfo.selectedReturnList.forEach((x) => {
        selectedClasses.push(x.selectedclass);
      });
    }
    return (
      flight && (
        <div>
          <div className="fs-14 white-color mb-1">
            {`${searchRequest.origin.split(':')[index]} - ${
              searchRequest.destination.split(':')[index]
            } , ${formatDate(
              getNewDate(flight.flightlegs[0].depdate),
              ONLY_DATE_MONTH_FORMAT,
            )}`}
          </div>
          <div className="results-footer__flight-info">
            <div className="fs-12 grey-color d-flex justify-content-between align-items-center">
              <span>{flight.flightlegs[0].validatingcarriername}</span>
              {selectedClasses.length > 0 && (
                <span className="fs-10">
                  Class: {selectedClasses.join(',')}
                </span>
              )}
            </div>
            <div className="results-footer__flight-info_details">
              <div>
                <AppFlightLogo
                  width="20px"
                  height="20px"
                  carrier={flight.flightlegs[0].carrier.substring(0, 2)}
                />
              </div>
              <div>{formatTimeString(flight.flightlegs[0].deptime)}</div>
              <div className="results-footer__seperator secondary-background-color" />
              <div>
                {formatTimeString(
                  flight.flightlegs[flight.flightlegs.length - 1].arrtime,
                )}
              </div>
              <div className="secondary-color fs-16">
                {formatCurrency(fareToShow.totalfq)}
              </div>
            </div>
          </div>
        </div>
      )
    );
  };

  return (
    <footer className="results-footer">
      <section className="results-footer__container d-flex justify-content-between align-items-center">
        <div className="d-flex flex-sm-row flex-column">
          <div className="d-flex gap-2 align-items-center flex-sm-row flex-column">
            {Object.keys(selectedFlight).map(
              (sec, index) =>
                selectedFlight[sec] &&
                getSelectedFlightDetail(
                  selectedFlight[sec],
                  selectedFare[sec],
                  true,
                  index,
                ),
            )}
          </div>
        </div>
        {showBookBtn && (
          <div className="d-flex flex-column gap-3 justify-content-end align-items-center">
            <div className="me-2 text-center d-flex flex-column">
              <span className="fs-12 white-color">Total Price</span>
              <h4 className="results-footer__price mb-0">
                {formatCurrency(getTotalAmount())}
              </h4>
            </div>
            <AppButton
              variant="primary"
              className="results-footer__book-btn"
              btnText={formattedMessage('continue_btn')}
              onClick={onBook}
            />
          </div>
        )}
      </section>
    </footer>
  );
}

DomMultiCityResultsFooter.defaultProps = {
  domint: 'domestic',
};

DomMultiCityResultsFooter.propTypes = {
  journeyType: PropTypes.string.isRequired,
  selectedFare: PropTypes.any.isRequired,
  searchRequest: PropTypes.any.isRequired,
  selectedFlight: PropTypes.any.isRequired,
  onBook: PropTypes.func.isRequired,
  domint: PropTypes.string,
  selectedClassInfo: PropTypes.any.isRequired,
};

export default DomMultiCityResultsFooter;
